import type { ResolvedReport } from '../../../../helpers/resolveReportDownload.js';
import { DownloadReport } from '../../../Reports/DownloadReport/DownloadReport.jsx';

type Props = {
  report: ResolvedReport;
  chatId: string;
};

const ReportBlock = ({ report, chatId }: Props) => (
  <div className="p-3">
    <DownloadReport
      chatId={chatId}
      filePath={report.filePath}
      pdfPath={report.pdfPath}
    />
  </div>
);

export { ReportBlock };
